/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var sentry = require('@sentry/browser');
var isProduction = process.env.NODE_ENV === 'production';
var PackageVersion = process.env.PKGRELEASE_VERSION;

var regex = /(.+\.)(.+)(\.oscato)(\.com.*)$/i;
var otherHost = 'wilderness';

function getEnvironment() {
    if (!location || !location.hostname || location.hostname === 'localhost') {
        return;
    }

    var env = location.hostname.match(regex);
    return env ? env[2] : otherHost;
}

function Sentry() {
    var environment = getEnvironment();

    if (isProduction && environment && environment !== otherHost) {
        sentry.init({
            dsn: 'https://8fc8b057e1be4435ae41e0d8372302c6@sentry.io/1306037',
            release: PackageVersion,
            environment: environment,
        });
    }
}

module.exports = Sentry;
